<template>
    <div id="app" style="background-color: #f4f5f5;">
        <navigation />
        <router-view />
        <footer class="text-muted bg-light mt-5 pt-5 pb-5 bg-white">
            <div class="container">
                <p>{{year}} © Universidad Galileo.</p>
            </div>
        </footer>
    </div>
</template>

<script>
import navigation from "@/components/NavBar.vue"

export default {
    name: "App",
    data() {
        return {
            year: new Date().getFullYear()
        }
    },
    components: {
        navigation
    },
};
</script>



// WEBPACK FOOTER //
// src/App.vue